module.exports = __webpack_public_path__ + "img/green_115.fc3c8cea.png";